/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { StakeManager, StakeManagerInterface } from "../StakeManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxUnstakeDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_abandonmentDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_escheatmentDelay",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_burnAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_devAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AbandonedRelayManagerStakeEscheated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "burnAddress",
        type: "address",
      },
    ],
    name: "BurnAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "devAddress",
        type: "address",
      },
    ],
    name: "DevAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "HubAuthorized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "removalTime",
        type: "uint256",
      },
    ],
    name: "HubUnauthorized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnerSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "abandonedTime",
        type: "uint256",
      },
    ],
    name: "RelayServerAbandoned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "keepaliveTime",
        type: "uint256",
      },
    ],
    name: "RelayServerKeepalive",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unstakeDelay",
        type: "uint256",
      },
    ],
    name: "StakeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "StakePenalized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "withdrawTime",
        type: "uint256",
      },
    ],
    name: "StakeUnlocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "StakeWithdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorizedHubs",
    outputs: [
      {
        internalType: "uint256",
        name: "removalTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakes",
    outputs: [
      {
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "unstakeDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "abandonedTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "keepaliveTime",
        type: "uint256",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionSM",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "getStakeInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelay",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "abandonedTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "keepaliveTime",
            type: "uint256",
          },
          {
            internalType: "contract IERC20",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "stakeInfo",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isSenderAuthorizedHub",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_burnAddress",
        type: "address",
      },
    ],
    name: "setBurnAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getBurnAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_devAddress",
        type: "address",
      },
    ],
    name: "setDevAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAbandonedRelayServerConfig",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "devAddress",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "abandonmentDelay",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escheatmentDelay",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.AbandonedRelayServerConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMaxUnstakeDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCreationBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "setRelayManagerOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "unstakeDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "stakeForRelayManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "unlockStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "withdrawStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "authorizeHubByOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "authorizeHubByManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "unauthorizeHubByOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayHub",
        type: "address",
      },
    ],
    name: "unauthorizeHubByManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "penalizeRelayManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "isRelayEscheatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "markRelayAbandoned",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "escheatAbandonedRelayStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayManager",
        type: "address",
      },
    ],
    name: "updateRelayKeepaliveTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakeManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakeManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StakeManager__factory extends ContractFactory {
  constructor(...args: StakeManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _maxUnstakeDelay: BigNumberish,
    _abandonmentDelay: BigNumberish,
    _escheatmentDelay: BigNumberish,
    _burnAddress: string,
    _devAddress: string,
    overrides?: Overrides & { from?: string }
  ): Promise<StakeManager> {
    return super.deploy(
      _maxUnstakeDelay,
      _abandonmentDelay,
      _escheatmentDelay,
      _burnAddress,
      _devAddress,
      overrides || {}
    ) as Promise<StakeManager>;
  }
  override getDeployTransaction(
    _maxUnstakeDelay: BigNumberish,
    _abandonmentDelay: BigNumberish,
    _escheatmentDelay: BigNumberish,
    _burnAddress: string,
    _devAddress: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _maxUnstakeDelay,
      _abandonmentDelay,
      _escheatmentDelay,
      _burnAddress,
      _devAddress,
      overrides || {}
    );
  }
  override attach(address: string): StakeManager {
    return super.attach(address) as StakeManager;
  }
  override connect(signer: Signer): StakeManager__factory {
    return super.connect(signer) as StakeManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakeManagerInterface {
    return new utils.Interface(_abi) as StakeManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakeManager {
    return new Contract(address, _abi, signerOrProvider) as StakeManager;
  }
}
